import { useSearchPageLoggedOutBrandTileReviewsQuery } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/LoggedOutBrandTileReviews/__internal__/useSearchPageLoggedOutBrandTileReviewsQuery";

export const useSearchPageLoggedOutBrandTileReviews = () => {
  const result = useSearchPageLoggedOutBrandTileReviewsQuery();
  return {
    reviews: result.data?.brand_tile_reviews,
    isFetching: result.isFetching,
  };
};
